// extracted by mini-css-extract-plugin
module.exports = {"header":"Table_SA_header__2mO3P","customColorTable":"Table_SA_customColorTable__2uNJW"};